export const MAX_HEIGHT = { height: '100%' };
export const MAX_HEIGHT_STYLE = { style: MAX_HEIGHT };



// WEBPACK FOOTER //
// ./src/Style.js